package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class TimerStateQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectCurrent(mapper: (
    id: String,
    running: Long,
    started_at: Long?,
    planned_minutes: Long,
    item_id: String?,
    skill_id: String?,
    paused_at: Long?,
    paused_accum_ms: Long,
    device: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-448_138_761, arrayOf("timer_state"), driver, "TimerState.sq",
      "selectCurrent",
      "SELECT timer_state.id, timer_state.running, timer_state.started_at, timer_state.planned_minutes, timer_state.item_id, timer_state.skill_id, timer_state.paused_at, timer_state.paused_accum_ms, timer_state.device, timer_state.created_at, timer_state.updated_at, timer_state.is_deleted, timer_state.deleted_at, timer_state.synced_at FROM timer_state WHERE id = 'current'") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2),
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12),
      cursor.getLong(13)
    )
  }

  public fun selectCurrent(): Query<Timer_state> = selectCurrent { id, running, started_at,
      planned_minutes, item_id, skill_id, paused_at, paused_accum_ms, device, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Timer_state(
      id,
      running,
      started_at,
      planned_minutes,
      item_id,
      skill_id,
      paused_at,
      paused_accum_ms,
      device,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectAll(mapper: (
    id: String,
    running: Long,
    started_at: Long?,
    planned_minutes: Long,
    item_id: String?,
    skill_id: String?,
    paused_at: Long?,
    paused_accum_ms: Long,
    device: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_777_966_367, arrayOf("timer_state"), driver, "TimerState.sq",
      "selectAll",
      "SELECT timer_state.id, timer_state.running, timer_state.started_at, timer_state.planned_minutes, timer_state.item_id, timer_state.skill_id, timer_state.paused_at, timer_state.paused_accum_ms, timer_state.device, timer_state.created_at, timer_state.updated_at, timer_state.is_deleted, timer_state.deleted_at, timer_state.synced_at FROM timer_state WHERE is_deleted = 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2),
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12),
      cursor.getLong(13)
    )
  }

  public fun selectAll(): Query<Timer_state> = selectAll { id, running, started_at, planned_minutes,
      item_id, skill_id, paused_at, paused_accum_ms, device, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Timer_state(
      id,
      running,
      started_at,
      planned_minutes,
      item_id,
      skill_id,
      paused_at,
      paused_accum_ms,
      device,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    running: Long,
    started_at: Long?,
    planned_minutes: Long,
    item_id: String?,
    skill_id: String?,
    paused_at: Long?,
    paused_accum_ms: Long,
    device: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-768_614_448, arrayOf("timer_state"), driver, "TimerState.sq",
      "selectDirty",
      "SELECT timer_state.id, timer_state.running, timer_state.started_at, timer_state.planned_minutes, timer_state.item_id, timer_state.skill_id, timer_state.paused_at, timer_state.paused_accum_ms, timer_state.device, timer_state.created_at, timer_state.updated_at, timer_state.is_deleted, timer_state.deleted_at, timer_state.synced_at FROM timer_state WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2),
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12),
      cursor.getLong(13)
    )
  }

  public fun selectDirty(): Query<Timer_state> = selectDirty { id, running, started_at,
      planned_minutes, item_id, skill_id, paused_at, paused_accum_ms, device, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Timer_state(
      id,
      running,
      started_at,
      planned_minutes,
      item_id,
      skill_id,
      paused_at,
      paused_accum_ms,
      device,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    running: Long,
    started_at: Long?,
    planned_minutes: Long,
    item_id: String?,
    skill_id: String?,
    paused_at: Long?,
    paused_accum_ms: Long,
    device: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2),
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12),
      cursor.getLong(13)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Timer_state> = selectByIdAnyState(id) { id_,
      running, started_at, planned_minutes, item_id, skill_id, paused_at, paused_accum_ms, device,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Timer_state(
      id_,
      running,
      started_at,
      planned_minutes,
      item_id,
      skill_id,
      paused_at,
      paused_accum_ms,
      device,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    running: Long,
    started_at: Long?,
    planned_minutes: Long,
    item_id: String?,
    skill_id: String?,
    paused_at: Long?,
    paused_accum_ms: Long,
    device: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_619_933_473, """
        |INSERT INTO timer_state(id, running, started_at, planned_minutes, item_id, skill_id, paused_at, paused_accum_ms, device, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 11) {
          bindString(0, id)
          bindLong(1, running)
          bindLong(2, started_at)
          bindLong(3, planned_minutes)
          bindString(4, item_id)
          bindString(5, skill_id)
          bindLong(6, paused_at)
          bindLong(7, paused_accum_ms)
          bindString(8, device)
          bindLong(9, created_at)
          bindLong(10, updated_at)
        }
    notifyQueries(-1_619_933_473) { emit ->
      emit("timer_state")
    }
  }

  public fun update(
    running: Long,
    started_at: Long?,
    planned_minutes: Long,
    item_id: String?,
    skill_id: String?,
    paused_at: Long?,
    paused_accum_ms: Long,
    device: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_274_987_281, """
        |UPDATE timer_state
        |SET running = ?, started_at = ?, planned_minutes = ?, item_id = ?, skill_id = ?, paused_at = ?, paused_accum_ms = ?, device = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 10) {
          bindLong(0, running)
          bindLong(1, started_at)
          bindLong(2, planned_minutes)
          bindString(3, item_id)
          bindString(4, skill_id)
          bindLong(5, paused_at)
          bindLong(6, paused_accum_ms)
          bindString(7, device)
          bindLong(8, updated_at)
          bindString(9, id)
        }
    notifyQueries(-1_274_987_281) { emit ->
      emit("timer_state")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(343_318_427,
        """UPDATE timer_state SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3)
        {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(343_318_427) { emit ->
      emit("timer_state")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(462_050_088,
        """UPDATE timer_state SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(462_050_088) { emit ->
      emit("timer_state")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_546_212_045,
        """UPDATE timer_state SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_546_212_045) { emit ->
      emit("timer_state")
    }
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("timer_state", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("timer_state", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_741_121_081,
        """SELECT timer_state.id, timer_state.running, timer_state.started_at, timer_state.planned_minutes, timer_state.item_id, timer_state.skill_id, timer_state.paused_at, timer_state.paused_accum_ms, timer_state.device, timer_state.created_at, timer_state.updated_at, timer_state.is_deleted, timer_state.deleted_at, timer_state.synced_at FROM timer_state WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "TimerState.sq:selectByIdAnyState"
  }
}
